<component-modal [showClose]="showCloseButton()" [showFooter]="false">
  <!-- Back button in header prefix -->
  @if (isPasswordStep()) {
    <button type="button" headerPrefix type="button" class="btn btn-icon btn-icon-secondary" (click)="onBackToEmail()">
      <custom-icon name="chevronLeft" size="16" viewBox="0 0 16 16" />
    </button>
  }

  <ng-container body>
    <form (keydown.enter)="$event.preventDefault()">
      <component-base-login
        [isLoading]="isLoading()"
        [currentProvider]="currentProvider()"
        [headerTitle]="headerTitle()"
        [headerSubtitle]="headerSubtitle()"
        [showTerms]="true"
        (oauthAction)="onOAuthAction($event)">
        <!-- Step 1: Email Input -->
        @if (isEmailStep()) {
          <component-input
            type="email"
            label="Email"
            [isFocused]="isEmailStep()"
            [value]="email()"
            [errorMessage]="emailError()"
            (valueChange)="onEmailChange($event!)"
            (enter)="onEmailContinue()" />

          <!-- Email warning (different message for login vs signup) -->
          @if (showEmailWarning()) {
            <div class="alert alert-warning d-flex align-items-start gap-3" role="alert">
              <custom-icon name="triangleAlert" class="text-warning" [size]="24" />
              <div class="d-flex flex-column gap-1">
                @if (isLoginMode()) {
                  <!-- Login: Email not found -->
                  <div class="alert-title">
                    We couldn't find an account for <span class="fw-bold">{{ email() }}</span>
                  </div>
                  <div class="alert-text">
                    Try another email or
                    <a [routerLink]="[loginRoutes.signup()]" (click)="onFooterLinkClick($event)" class="alert-link">
                      create an account
                    </a>
                  </div>
                } @else {
                  <!-- Signup: Email already exists -->
                  <div class="alert-text">
                    An account with <span class="fw-bold">{{ email() }}</span> already exists. Try another email or
                    <a [routerLink]="[loginRoutes.login()]" (click)="onFooterLinkClick($event)" class="alert-link">log in</a>
                  </div>
                }
              </div>
            </div>
          }

          <component-button-with-loading
            cssClass="btn btn-primary btn-lg w-100"
            [disabled]="!email() || isLoading()"
            [isLoading]="isLoading()"
            (click)="onEmailContinue()">
            Continue
          </component-button-with-loading>
        }

        <!-- Step 2: Password Input -->
        @if (isPasswordStep()) {
          <!-- Email (disabled) -->
          <component-input type="email" label="Email" [value]="email()" [disabled]="true" />

          <!-- Password -->
          <component-input
            type="password"
            label="Password"
            [value]="password()"
            [isClearable]="true"
            [isFocused]="isPasswordStep()"
            [errorMessage]="passwordError()"
            (valueChange)="onPasswordChange($event!)"
            (enter)="onPasswordAction()" />

          <!-- Forgot password link (only for login and not in upgrade mode) -->
          @if (isLoginMode() && !isUpgradeFlow()) {
            <div class="text-start">
              <button type="button" class="btn btn-link" (click)="onForgotPassword()">Forgot password?</button>
            </div>
          }

          <component-button-with-loading
            cssClass="btn btn-primary btn-lg w-100"
            [disabled]="!password() || isLoading()"
            [isLoading]="isLoading()"
            (click)="onPasswordAction()">
            {{ passwordButtonText() }}
          </component-button-with-loading>
        }

        <!-- Footer -->
        <p authFooter class="d-flex justify-content-center gap-2 mb-0">
          {{ footerText() }}
          <button type="button" class="btn btn-link" (click)="onFooterLinkClick()">{{ footerLinkText() }}</button>
        </p>
      </component-base-login>
    </form>
  </ng-container>
</component-modal>
